/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useApiRelojChecador from "../../api/administracion/useApiRelojChecador";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import agGridHelper from "../../shared/ag-grid-helper";
import Filtro from "../../shared/componentes/filtro";
import FieldCalendarRange from "../../shared/controls/fieldCalendarRange";
import FieldMultiSelect from "../../shared/controls/fieldMultiSelect";
import { Sidebar } from "primereact/sidebar";
import useSeguridad from "../../Seguridad/useSeguridad";
import constantes from "../../catalogos/constantes";

const Filtros = ({ filtro, onChange, empleadosACargo, permisoRH }) => {
    return (
        <>
            <FieldMultiSelect
                name="empresaId"
                source="empresas"
                label="Empresa"
                colLg={2}
                colMd={3}
                value={filtro?.empresaId}
                onChange={onChange}
                showFilter
                valueAsId
            />

            {permisoRH ? (
                <FieldMultiSelect
                    name="empleadosId"
                    source="empleados"
                    label="Empleado"
                    colLg={2}
                    colMd={3}
                    value={filtro?.empleadosId}
                    onChange={onChange}
                    showFilter
                    valueAsId
                />
            ) : (
                <FieldMultiSelect
                    name="empleadosId"
                    label="Empleado"
                    colLg={2}
                    colMd={3}
                    options={empleadosACargo}
                    optionLabel="nombre"
                    optionValue="id"
                    value={filtro?.empleadosId}
                    onChange={onChange}
                    showFilter
                    valueAsId
                />
            )}

            <FieldCalendarRange
                name="fechas"
                label="Fechas"
                colLg={2}
                colMd={3}
                value={filtro?.fechas}
                onChange={onChange}
            />
        </>
    );
};

const RelojChecador = () => {
    const seguridad = useSeguridad();
    const permisoRH = seguridad.tieneAcceso(constantes.opciones.permisoRelojChecador);

    const api = useApiRelojChecador();

    const [datos, setDatos] = useState([]);
    const [empleadosACargo, setEmpleadosACargo] = useState([]);
    const filtroKey = "FiltroRelojChecador";

    const [gridApi, setGridApi] = useState(null);
    const [sidebarVisible, setSidebarVisible] = useState(false);

    const onGridReady = (params) => setGridApi(params.api);

    const obtenerUsuario = () => {
        const user = localStorage.getItem("user-ximple");
        if (!user) return null;
        try {
            return JSON.parse(user);
        } catch {
            return null;
        }
    };

    const usuario = obtenerUsuario();
    const jefeId = usuario?.empleadoId ?? null;

    // Cargar empleados a cargo (si NO es RH)
    useEffect(() => {
        async function cargar() {
            if (!jefeId || permisoRH) return;

            const empleados = await api.obtenerEmpleadosPorJefe(jefeId);
            setEmpleadosACargo(empleados);
        }
        cargar();
    }, [jefeId, permisoRH]);

    async function buscar(filtro, paramsApi) {
        const filtroBase = filtro || {};

        let empleadosSeleccionados =
            (filtroBase?.empleadosId ?? []).map(x => x.id ?? x);

        // Si NO es RH → forzar empleados a cargo si no seleccionó
        if (!permisoRH) {
            if (!empleadosSeleccionados || empleadosSeleccionados.length === 0) {
                empleadosSeleccionados = empleadosACargo.map(e => e.id);
            }
        }

        const filtroFinal = {
            fechas: filtroBase?.fechas,
            empresaId: filtroBase?.empresaId ?? [],
            empleadosId: empleadosSeleccionados
        };

        agGridHelper.showLoad(gridApi, paramsApi, true);

        const response = await api.obtener(filtroFinal);
        setDatos(response);

        agGridHelper.hideLoad(gridApi, paramsApi, false);
    }

    return (
        <>
            <Sidebar
                visible={sidebarVisible}
                position="right"
                dismissable={false}
                className="p-sidebar-xl"
                onHide={() => setSidebarVisible(false)}
            />

            <Filtro
                filtroKey={filtroKey}
                handleSubmit={buscar}
                filtrarAlInicio={false}
                classButtons="field-iconos btn-group"
            >
                {/* IMPORTANTE: aquí NO pasamos filtro ni onChange,
                    el componente Filtro se encarga de inyectarlos */}
                <Filtros
                    empleadosACargo={empleadosACargo}
                    permisoRH={permisoRH}
                />
            </Filtro>

            <div className="ag-theme-balham grid-principal">
                <AgGridReact
                    enableSorting
                    enableFilter
                    pagination
                    onGridReady={onGridReady}
                    rowData={datos}
                    frameworkComponents={{
                        dateFormatter: agGridHelper.DateTimeFormatter
                    }}
                    overlayLoadingTemplate={agGridHelper.loadingOverlay}
                    defaultColDef={agGridHelper.defaultColumns}
                    rowHeight={35}
                >
                    <AgGridColumn
                        field="fecha"
                        headerName="FECHA"
                        maxWidth={200}
                        cellRenderer="dateFormatter"
                    />

                    <AgGridColumn
                        field="empleado"
                        headerName="EMPLEADO"
                        minWidth={280}
                    />

                    <AgGridColumn
                        field="horaEntrada"
                        headerName="HORA ENTRADA"
                        valueFormatter={(p) =>
                            p.value
                                ? new Date(p.value).toLocaleTimeString("es-MX", {
                                      hour: "2-digit",
                                      minute: "2-digit"
                                  })
                                : ""
                        }
                    />

                    <AgGridColumn
                        field="horaSalida"
                        headerName="HORA SALIDA"
                        valueFormatter={(p) =>
                            p.value
                                ? new Date(p.value).toLocaleTimeString("es-MX", {
                                      hour: "2-digit",
                                      minute: "2-digit"
                                  })
                                : ""
                        }
                    />

                    <AgGridColumn field="sumaHoras" headerName="SUMA DE HORAS" />
                    <AgGridColumn field="empresa" headerName="EMPRESA" />
                </AgGridReact>
            </div>
        </>
    );
};

export default RelojChecador;
